<template>
  <div id="monerisCheckout" style="overflow: hidden">
    <v-alert v-model="showAlert" :type="alertType">{{ alertMessage }}</v-alert>
  </div>
</template>

<script>
import { api } from "@/plugins/api";

// Page d'affichage de la modale Moneris Checkout
export default {
  name: "MonerisCheckout",
  props: {
    idFacture: String,
  },
  data() {
    return {
      // Instance Moneris
      moneris: null,
      // Token de paiement généré par Moneris
      token: null,
      valid: true,
      showAlert: false,
      alertMessage: null,
      alertType: "success",
    };
  },
  mounted() {
    // Validation des paramètres obligatoires
    if (this.validerParametres()) {
      // Chargement du script de la librairie Moneris checkout
      this.$loadScript(process.env.VUE_APP_MONERIS_CHECKOUT).then(() => {
        // eslint-disable-next-line
        this.moneris = new monerisCheckout();
        this.moneris.setMode(process.env.VUE_APP_MONERIS_ENVIRONMENT);
        this.moneris.setCheckoutDiv("monerisCheckout");
        this.moneris.setCallback("page_loaded", this.logEvent);
        this.moneris.setCallback("cancel_transaction", this.logEvent);
        this.moneris.setCallback("error_event", this.logEvent);
        this.moneris.setCallback("payment_receipt", this.creerTransaction);
        this.moneris.setCallback("payment_complete", this.paymentComplete);

        const self = this;
        this.preloadRequest({
          factureId: this.idFacture,
          langue: process.env.VUE_APP_DEFAULT_LANG,
        })
          .then((response) => {
            self.moneris.startCheckout(response.data);
            self.token = response.data;
          })
          .catch((err) => {
            self.alertMessage = err.message;
            self.showAlert = true;
            self.alertType = "error";
          });
      });
    } else {
      console.log(
        "Erreur : Veuillez vérifier les paramètres envoyés à l'application."
      );
    }
  },
  methods: {
    logEvent(e) {
      this.alertMessage = e.response_code;
      this.showAlert = true;
      this.alertType = "error";
    },
    validerParametres() {
      if (this.isNullOrEmpty(this.idFacture)) {
        return false;
      } else {
        return true;
      }
    },
    isNullOrEmpty(value) {
      return value === undefined || value === "" || value === null;
    },
    // Webservice de création de la transaction
    creerTransaction() {
      const self = this;
      this.receiptRequest({ factureId: this.idFacture, token: this.token })
        .then((response) => {
          if (response.data == true) {
            self.$emit("paiementEudonetComplete");
          }
        })
        .catch((err) => {
          self.alertMessage = err.message;
          self.showAlert = true;
          self.alertType = "error";
        });
    },
    paymentComplete() {
      this.moneris.closeCheckout(" ");
      this.$emit("customClose");
    },
    preloadRequest: (payload) =>
      api.get(
        "moneris-checkout/" + payload.factureId + "/preload/" + payload.langue
      ),
    receiptRequest: (payload) =>
      api.post("moneris-checkout/" + payload.factureId + "/receipt", {
        token: payload.token,
      }),
  },
};
</script>

<style scoped>
</style>
